import { format } from 'date-fns/format';
import { ja } from 'date-fns/locale/ja';

export function fmtDate(d: Date | string | null): string {
  if (!d) {
    return '-';
  }
  // 画面は日本語なので、既定ロケールの "Oct 15, 2026" ではなく "2026/10/15"
  return format(d, 'PP', { locale: ja });
}
